import type { LoginResponse, MeResponse, RefreshResponse, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { endpoints } from "@/shared/api/endpoints";
import type {
	AuthData,
	AuthTokens,
	LoginRequest,
	LogoutRequest,
	RefreshTokenRequest,
	User,
} from "../types";

export const authService = {
	async login(data: LoginRequest): Promise<AuthData> {
		const raw = data.username.trim();
		const isPhone = /^\+?\d{9,}$/.test(raw.replace(/\s+/g, ""));
		const payload = isPhone
			? { phone: raw.startsWith("+") ? raw : `+998${raw}`, password: data.password }
			: { username: raw, password: data.password };
		const response = await apiClient.post<LoginResponse>(endpoints.auth.login, payload);
		const { user: backendUser, accessToken, refreshToken } = response.data.data;

		const roleMap: Record<string, string> = {
			SUPER_ADMIN: "super",
			ORG_ADMIN: "admin",
			SALES_MANAGER: "manager",
			super_admin: "super",
			org_admin: "admin",
			sales_manager: "manager",
		};

		const fullName =
			backendUser.fullName ||
			`${backendUser.firstName || ""} ${backendUser.lastName || ""}`.trim() ||
			"Foydalanuvchi";

		return {
			user: {
				id: backendUser.id,
				phone: backendUser.phone || backendUser.email || backendUser.username || "",
				role: (roleMap[backendUser.role] || "manager") as any,
				isActive: backendUser.isActive,
				createdAt: backendUser.createdAt,
				fullName,
				email: backendUser.email,
				username: backendUser.username,
				firstName: backendUser.firstName,
				lastName: backendUser.lastName,
				orgId: backendUser.orgId,
				orgName: backendUser.orgName,
			},
			accessToken,
			refreshToken,
		};
	},

	async refresh(data: RefreshTokenRequest): Promise<AuthTokens> {
		const response = await apiClient.post<RefreshResponse>(endpoints.auth.refresh, data);
		const { accessToken, refreshToken } = response.data.data;
		return { accessToken, refreshToken };
	},

	async logout(data: LogoutRequest): Promise<void> {
		await apiClient.post<SuccessResponse<{ message: string }>>(endpoints.auth.logout, data);
	},

	async getMe(): Promise<User> {
		const response = await apiClient.get<MeResponse>(endpoints.auth.me);
		const backendUser = response.data.data;

		const roleMap: Record<string, string> = {
			SUPER_ADMIN: "super",
			ORG_ADMIN: "admin",
			SALES_MANAGER: "manager",
			super_admin: "super",
			org_admin: "admin",
			sales_manager: "manager",
		};

		const fullName =
			backendUser.fullName ||
			`${backendUser.firstName || ""} ${backendUser.lastName || ""}`.trim() ||
			"Foydalanuvchi";

		return {
			id: backendUser.id,
			phone: backendUser.phone || backendUser.email || backendUser.username || "",
			role: (roleMap[backendUser.role] || "manager") as any,
			isActive: backendUser.isActive,
			createdAt: backendUser.createdAt,
			fullName,
			email: backendUser.email,
			username: backendUser.username,
			firstName: backendUser.firstName,
			lastName: backendUser.lastName,
			orgId: backendUser.orgId,
			orgName: backendUser.orgName,
		};
	},
};
